import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import { FETCH_CARD_PENDING_CUSTOMERS } from './types';

const notifyError = (error, fallback) => {
    NotificationManager.error(error.response?.data?.msg || fallback);
};

export const fetchCardPendingCustomers = filter => dispatch => api
    .get('/card-pending-customers', { params: filter })
    .then(response => {
        dispatch({ type: FETCH_CARD_PENDING_CUSTOMERS, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể tải danh sách khách hàng chờ làm thẻ.');
        return Promise.reject(error);
    });

export const assignCardPendingCustomersToStaff = data => () => api
    .post('/card-pending-customers/assign-to-staff', data)
    .then(response => {
        NotificationManager.success(response.data.msg);
        return response.data.data;
    })
    .catch(error => {
        notifyError(error, 'Không thể giao thẻ cho nhân viên.');
        return Promise.reject(error);
    });

export const exportCardPendingCustomers = filter => () => api
    .post('/card-pending-customers/export', filter)
    .then(response => response.data.data)
    .catch(error => {
        notifyError(error, 'Không thể xuất danh sách khách hàng chờ làm thẻ.');
        return Promise.reject(error);
    });
